export const getLoaderStatus = (state, getters, rootState, rootGetters) => state.loaderStatus;